import React from 'react'

function WebInternships() {
  return (
    <div>WebInternships</div>
  )
}

export default WebInternships